import React, { memo, useRef, useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import {WIDTH, HEIGHT, PADDING} from './constants.js';
import Colors from 'components/Colors.js';

const colors = new Colors();

const DOUBLE_CLICK = 250;
window.blur = 6;
window.macroOpacity = 0.7;

window.r = 50;
window.g = 55;
window.b = 65;


const PlaneCanvas = ({
    ctxt,
    gradientColor,
    macroPaths,
    paths,
    forcePaths,
    splineTension,
    blur,
    setMacroToShow,
    macroToShow,
    parameters,
    selection,
    startDragging,
    coords,
    effect,
    setEffectParameterValues,
    ... props
}) => { 
    let ref = useRef(undefined);
    let width = useRef(WIDTH);
    let height = useRef(HEIGHT);

    useEffect(() => {
        ctxt.current = ref.current.getContext('2d');
        ctxt.current.scale(window.devicePixelRatio, window.devicePixelRatio);
    }, []);

    useEffect(() => {
        if (WIDTH !== width.current) {
            ctxt.current.scale(window.devicePixelRatio, window.devicePixelRatio);
            width.current = WIDTH;
            height.current = HEIGHT;
        }
    }, [WIDTH, HEIGHT]);

    useEffect(() => {
        if (!ctxt.current ){
            return;
        }
        window.requestAnimationFrame(draw);
    }, [splineTension, gradientColor, props.selectedColor, coords, parameters, macroToShow, props.filteredParameters, props.isRegionMode]);

    const draw = useCallback(() => {
        let c = ctxt.current;
        c.clearRect(0,0,WIDTH,HEIGHT);
        if (selection) {
            c.fillStyle="#b00909";
            c.fillRect(
                selection.x1,
                selection.y1,
                Math.abs(selection.x2 - selection.x1),
                Math.abs(selection.y2 - selection.y1));
        }

        // draw the group lines
        if (!props.filteredParameters) {
            for (let group of effect.groups) {
                let parameters = group._parameters.filter(
                    x => !x.planeMacro);
                let macros = Array.from(new Set(group._parameters.filter(
                    x => x.planeMacro).map(x => x.planeMacro)));
                let points = parameters.map(p => p.getCoordinates());
                points = [... points, ... macros.map(m => m.coordinates)];
                let curve = "M " + points.map(point => point.x + ' ' + point.y).join(', ');
                let path = new Path2D(curve);
                c.setLineDash([1]);
                c.strokeStyle = 
                    colors.transparent(colors.saturate(colors.getColorForHash(group.id), 2),
                                       0.6);
                c.stroke(path);
            }
        }

        c.setLineDash([]);
        let macros = [
            ... effect.macros.filter(x => !props.selected.includes(x)),
            ... props.selected.filter(x => effect.macros.includes(x))
        ];

        let i=0;
        // draw the macro blobs
        for (let macro of macros) {
            let {x,y,diameter, d} = macro.getEasyBlob();
            let path = new Path2D(d);
            let fill = macro.color;
            //c.filter = 'blur(' + window.blur + 'px)';
            if (gradientColor) {
                var grd = c.createRadialGradient(x,y,diameter,x+15,y+40,5);
                grd.addColorStop(0, gradientColor);
                grd.addColorStop(1, colors.transparent(colors.saturate(fill, 2), props.isFiltered ? 0.1 : window.macroOpacity));
                
                c.fillStyle = grd;
            } else {
                c.fillStyle = colors.transparent(colors.saturate(fill, 2), props.isFiltered ? 0.1 : window.macroOpacity);
            }
            c.fill(path);
            if (macroToShow === macro || props.selected.includes(macro)) {
                c.setLineDash([3]);
                c.lineWidth = 1;
                c.strokeStyle = 'white';
                c.stroke(path);
            }
            //c.filter = 'none';
            macroPaths.current[macro.id] = path;
            i++;
        }
        
        // draw the actual paramter circles (if not in macro)
        for (let parameter of parameters) {
            let {id} = parameter;
            if (!coords[id]) {
                continue;
            }
            let {x,y} = coords[id];
            let circle = new Path2D();
            circle.arc(x,y, 7, 0, Math.PI * 2);
            if (props.selected.includes(parameter)) {
                c.lineWidth = 2;
                c.strokeStyle=colors.getColorForHash(parameter.name);
                c.stroke(circle);
                c.fillStyle="black";
            } else {
                c.fillStyle=colors.getColorForHash(parameter.name);
            }
            c.fill(circle);

            paths.current[id] = circle;
        }
    }, [props.selected, gradientColor, coords, parameters, macroToShow, props.filteredParameters, props.isRegionMode]);
   
    let style = {
        width: WIDTH,
        height: HEIGHT
    };
    if (blur > 0) {
        style.filter = `blur(${blur}px)`;
    }
    return (
        <canvas
          style={style}
          className="canvas-drawer"
         width={window.devicePixelRatio*WIDTH} height={window.devicePixelRatio*HEIGHT}  ref={ref}>
        </canvas >
    );
};

export default PlaneCanvas;
